// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3zjhW","Text":"Footer_Text__1COE3"};